/**
 * Paths served outside the Fondation application shell.
 *
 * A page listed here is bootstrapped by `public/public-main.ts` instead of `app-main.ts`, so it never
 * touches the Fondation SDK and never triggers the login flow. Fondation's anonymous mode is an
 * all-or-nothing application setting, so a single publicly reachable page has to opt out of the shell
 * rather than out of a route guard.
 */
export const SMS_CONSENT_PATH = '/consentement-sms';

/**
 * Reads the school service centre slug out of `/consentement-sms/<slug>`.
 *
 * Each centre publishes its own white-labelled link; the bare path is the front door, where the
 * visitor picks their centre from a list instead.
 */
export const getSmsConsentSlug = (pathname: string): string | null => {
  const normalized = pathname.replace(/\/+$/, '');
  if (!normalized.startsWith(`${SMS_CONSENT_PATH}/`)) return null;

  const slug = normalized.slice(SMS_CONSENT_PATH.length + 1);
  return slug.length > 0 && !slug.includes('/') ? decodeURIComponent(slug) : null;
};

/** Whether a browser location should be handed to the public bootstrap. */
export const isPublicRoute = (pathname: string): boolean => {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return normalized === SMS_CONSENT_PATH || getSmsConsentSlug(pathname) !== null;
};
